import * as Segment from '@hotjar/webapp/domains/common/tracking/segment';

export const logoutIfAlreadyIdentified = (): void => {
  Segment.logoutIfAlreadyIdentified();
};
